<template>
  <div class="event-detail">
    <NavHeaderBar :showSearch="false" :navBarTitle="`${eventInfoObj.eventType === 1 ? $t('form.popUp') : eventInfoObj.eventType === 2 ? $t('form.brandDay') : ''}`" @backReturn="backReturn">
      <div class="right-header" @click="toPage(`/createEvent?eventId=${eventId}&customerId=${eventInfoObj.customerId}&customerName=${eventInfoObj.targetName}&pageType=${pageType}&eventType=${eventInfoObj.eventType}`, 'detail')">
        {{ $t('button.detail') }}
      </div>
    </NavHeaderBar>
    <div class="top-content">
      <div class="header-info">
        <!-- Header: Title & Status Tag -->
        <div class="card-header" v-if="eventInfoObj.policy">
          <div class="title-row">
            <span class="event-title txt-ellipsis">{{ eventInfoObj.policy.policyName }}</span>
            <span class="status-tag txt-ellipsis">{{ eventInfoObj.policy.modality === 0 ? $t('shared.onSite') : eventInfoObj.policy.modality === 1 ? $t('shared.offSite') : eventInfoObj.policy.modality === 2 ? $t('shared.webSite') : '' }}</span>
          </div>
        </div>

        <!-- User Info -->
        <div class="info-row" v-if="eventInfoObj.createUserName">
          <img src="@/assets/images/map_user.png" class="row-icon" />
          <span class="info-text">{{ $t('shared.bA') }}: {{ eventInfoObj.createUserName }}</span>
        </div>

        <!-- Time Info & Status -->
        <div class="info-row">
          <img src="@/assets/images/map_time.png" class="row-icon" />
          <div class="time-content">
            <span v-if="![null, ''].includes(eventInfoObj.status)" class="time-status-badge txt-ellipsis" :class="{'status-not-started': eventInfoObj.status === 0, 'status-starting': eventInfoObj.status === 1, 'status-end': eventInfoObj.status === 2, 'status-archive': eventInfoObj.status === 10}">{{ eventInfoObj.status === 0 ? $t('shared.notStarted') : eventInfoObj.status === 1 ? $t('shared.startingNow') : eventInfoObj.status === 2 ? $t('shared.end') : eventInfoObj.status === 10 ? $t('shared.nonEditable') : '' }}</span>
            <span class="time-range">{{ eventInfoObj.startTime }} ~ {{ eventInfoObj.endTime }}</span>
          </div>
        </div>

        <!-- Tags -->
        <div class="info-row tags-row" v-if="eventInfoObj.policy">
          <img src="@/assets/images/map_jian.png" class="row-icon" /> <!-- Placeholder icon if not exact -->
          <div class="tags-list">
            <span v-for="(tag, tIndex) in eventInfoObj.policy.policyProductList" :key="tIndex" class="product-tag" :style="{border: `1px solid ${tag.productColor}`, color: tag.productColor}">{{ tag.productName }}</span>
          </div>
        </div>

        <!-- Store Info -->
        <div class="info-row store-row">
          <img v-if="eventInfoObj.eventType === 2" src="@/assets/images/sd.png" class="row-icon" />
          <img v-else src="@/assets/images/store.png" class="row-icon" />
          <span class="store-name van-ellipsis">{{ eventInfoObj.targetName }}</span>
        </div>

        <div class="info-row" style="justify-content: flex-end;" v-if="eventInfoObj.address">
          <div class="navigate-info" @click="getCurrentLoc">
            <img src="@/assets/images/daohang_white.png" class="row-icon" alt="">
            <span>{{ $t('button.navigate') }}</span>
          </div>
        </div>
      </div>
      <van-tabs class="event-tabs" v-model="eventActive" type="card" color="#307bff" :before-change="handleBeforeTabChange" @change="handleTabChange">
        <van-tab :title="$t('shared.feedback')">
          <!-- <Feedback v-if="eventDetailsInfo.feedback" ref="feedbackRef" :paramsUrl="paramsUrl" :eventDetailsInfo="eventDetailsInfo" @getEventInfoData="getEventInfoData" @choiceProduct="choiceProduct" /> -->
        </van-tab>
        <van-tab :title="$t('button.sellOut')" v-if="eventInfoObj.eventType !== 2">
          <!-- <SellOut ref="sellOutRef" :productData="productData" :paramsUrl="paramsUrl" :eventDetailsInfo="eventDetailsInfo" /> -->
        </van-tab>
        <van-tab :title="$t('shared.materialSample')">
          <!-- <MaterialSample ref="materialSampleRef" :paramsUrl="paramsUrl" :productData="productData" :eventDetailsInfo="eventDetailsInfo" /> -->
        </van-tab>
      </van-tabs>
    </div>
    <div v-if="([0].includes(eventActive) || ([1].includes(eventActive) && eventInfoObj.eventType === 1)) && scheduleList.length > 0" class="product-name-header">
      <van-popover
        v-model="showPopover"
        trigger="click"
        placement="bottom-start"
      >
        <template #reference>
          <div class="title-wrapper">
            <div class="title-name txt-ellipsis">
              {{ $t('shared.report') }}：{{ currentSchedule.newReportData }}
              <van-icon name="play" class="arrow-icon" :class="{ 'expanded': showPopover }" />
            </div>
            <div class="bot-line"></div>
          </div>
        </template>
        <div class="popover-content">
          <div
            v-for="item in scheduleList"
            :key="item.schedule"
            class="popover-item"
            :class="{ 'active': currentSchedule.schedule === item.schedule, 'disabled': item.isLock }"
            @click.stop="handleReport(item)"
          >
            <div class="icon-wrapper">
              <van-icon v-if="currentSchedule.schedule === item.schedule" name="success" />
              <van-icon v-else-if="item.isLock" name="lock" />
            </div>
            <span class="text">{{ item.reportDate }}</span>
          </div>
        </div>
      </van-popover>
    </div>
    <div class="main-content">
      <Feedback ref="feedbackRef" v-if="eventActive === 0 && eventInfoObj.eventType === 1" @changeTab="changeTab" :eventInfoObj="eventInfoObj" :scheduleList="scheduleList" />
      <BrandFeedback ref="feedbackRef" v-if="eventActive === 0 && eventInfoObj.eventType === 2" @changeTab="changeTab" :eventInfoObj="eventInfoObj" />
      <SellOut ref="sellOutRef" v-else-if="eventInfoObj.eventType !== 2 && eventActive === 1" :eventId="eventId" :eventInfoObj="eventInfoObj" />
      <MaterialSample v-else-if="eventActive === 2 || (eventInfoObj.eventType === 2 && eventActive === 1)" :eventId="eventId" :eventInfoObj="eventInfoObj" />
    </div>
    <div class="footer-btn" v-if="!eventInfoObj.isDisable">
      <van-button v-if="eventActive === 0 && this.currentSchedule.schedule !== '-1'" class="previous-btn" :class="{'save-btn': eventInfoObj.eventType === 2}" type="default" block @click="handleSubmit('save')">{{ $t('button.save') }}</van-button>
      <van-button v-if="eventInfoObj.eventType !== 2 && eventInfoObj.status !== 0 && !(eventActive === 0 && this.currentSchedule.schedule === '-1')" class="next-btn" type="info" block @click="handleSubmit('addOrder')">{{ $t('button.addSalesOrder') }}</van-button>
      <van-button v-if="eventInfoObj.eventType !== 2 && eventActive === 0 && this.currentSchedule.schedule === '-1'" class="next-btn" type="info" block @click="toPage(`/shared/storeTag?eventId=${eventId}`, 'tag')">{{ $t('button.storeTagDetermination') }}</van-button>
    </div>
  </div>
</template>
<script>
import { arsEventInfoApi, arsEventFeedbackAddOrUpdateApi, eventSdFeedbackAddOrUpdate } from '@/api/event'
import { setCustomerTagApi } from '@/api/shared'
import { mapMutations, mapState } from 'vuex'
import { Toast, Notify } from 'vant'
import Feedback from './components/detail/feedback'
import BrandFeedback from './components/detail/brandFeedback'
export default {
  name: 'EventDetail',
  components: {
    Feedback,
    BrandFeedback,
    MaterialSample: () => import('./components/detail/materialSample'),
    SellOut: () => import('./components/detail/sellOut')
    // [Popover.name]: Popover
  },
  data () {
    return {
      eventId: '',
      eventInfoObj: {},
      eventActive: 0,
      showPopover: false,
      currentSchedule: {}, // Default selection
      scheduleList: [],
      pageType: ''
    }
  },
  computed: {
    ...mapState('event', ['eventInfo']),
    productListTotal () {
      return this.sellOutList.reduce((acc, curr) => acc + curr.productCount, 0)
    },
    tagIsShow () {
      return !this.eventInfoObj.scheduleList || (this.eventInfoObj.scheduleList.length === 0 || this.eventInfoObj.scheduleList[this.eventInfoObj.scheduleList.length - 2].schedule === this.eventInfo.schedule)
    }
  },
  activated () {
    this.eventId = this.$route.query.eventId
    this.pageType = this.$route.query.pageType || ''
    const activeTab = sessionStorage.getItem('eventDetail_activeTab')
    if (activeTab !== null) {
      this.eventActive = Number(activeTab)
      sessionStorage.removeItem('eventDetail_activeTab')
    } else {
      this.eventActive = 0
    }
    this.getEventInfo()
  },
  beforeRouteLeave (to, from, next) {
    if (['/sellOutAdd', '/selectMaterial', '/shared/selectSample'].includes(to.path)) {
      sessionStorage.setItem('eventDetail_activeTab', this.eventActive)
    } else {
      sessionStorage.removeItem('eventDetail_activeTab')
    }
    next()
  },
  methods: {
    ...mapMutations('event', ['SET_EVENTINFO']),
    handleBeforeTabChange (nextIndex) {
      if (this.eventActive === 0) {
        return this.handleSubmit('save').then(() => {
          Toast.clear()
          this.eventActive = nextIndex
          return true
        }).catch(() => {
          Toast.clear()
          return false
        })
      } else {
        this.eventActive = nextIndex
        return true
      }
    },
    handleTabChange (val) {
      if (val === 0) {
        this.$nextTick(() => {
          this.$refs.feedbackRef.getFeedbackInfo()
          this.$refs.feedbackRef.getSummaryInfo()
        })
      }
    },
    handleSubmit (type) {
      return new Promise((resolve, reject) => {
        if (type === 'save' && this.$refs.feedbackRef && !this.eventInfoObj.isDisable && this.currentSchedule.schedule !== '-1') {
          const { eventType } = this.eventInfoObj
          if (eventType !== 2 && this.tagIsShow && this.eventInfoObj.afterCustomerTag === '' && this.eventInfoObj.isWaiveCustomer !== 1) {
            Toast(this.$t('tips.storeTagIsRequired'))
            return false
          }
          const { feedbackInfo, saleBeforeProduct = [], saleTargetProduct = [], projectBuyList = [], productSaleList = [], buyBrandList = [] } = this.$refs.feedbackRef
          const data = {
            schedule: this.currentSchedule.schedule,
            eventId: this.eventId,
            feedback: {
              ...feedbackInfo,
              imgUrl: feedbackInfo.imgUrl.map(subItem => subItem.url).join(','),
              poImgUrl: eventType === 2 ? feedbackInfo.poImgUrl.map(subItem => subItem.url).join(',') : ''
            },
            saleBeforeProduct: saleBeforeProduct,
            saleTargetProduct: saleTargetProduct,
            projectBuyList: projectBuyList,
            productSaleList: productSaleList,
            buyBrandList: buyBrandList
          }
          const tagData = {
            eventId: this.eventId,
            customerTag: this.eventInfoObj.afterCustomerTag
          }
          Toast.loading({
            message: this.$t('shared.loading'),
            forbidClick: true,
            duration: 0
          })
          const requestApi = eventType === 2 ? eventSdFeedbackAddOrUpdate : arsEventFeedbackAddOrUpdateApi
          requestApi(data).then(res => {
            // 成功通知
            Notify({ type: 'success', message: this.$t('tips.successSave'), duration: 1500 })
            if (eventType === 2) {
              Toast.clear()
              resolve()
            } else {
              setCustomerTagApi(tagData).then(res => {
                Toast.clear()
                resolve()
              }).catch((err) => {
                reject(err)
              })
            }
          }).catch(err => {
            console.log('err', err)
            reject(err)
          })
        } else if (type === 'addOrder') {
          this.$router.push({
            path: '/sellOutAdd',
            query: { eventId: this.eventInfo.eventId, sellOutId: '', eventActive: this.eventActive }
          })
          resolve()
        } else {
          resolve()
        }
      })
    },
    handleReport (params) {
      if (params.isLock) return
      if (this.currentSchedule.schedule !== params.schedule) {
        this.currentSchedule = JSON.parse(JSON.stringify(params))
        this.SET_EVENTINFO({ eventId: this.eventId, schedule: params.schedule })
        if (this.eventActive === 0) {
          if (params.schedule !== '-1') {
            this.$refs.feedbackRef.getFeedbackInfo()
          } else {
            this.$refs.feedbackRef.getSummaryInfo()
          }
        } else {
          this.$refs.sellOutRef.getEventSellOutGeneralData()
          this.$refs.sellOutRef.getListPageInfo()
        }
      }
      this.showPopover = false
    },
    getEventInfo () {
      Toast.loading({
        message: this.$t('shared.loading'),
        forbidClick: true,
        duration: 0
      })
      // xxx
      arsEventInfoApi(this.eventId, this.eventInfo.schedule).then(res => {
        Toast.clear()
        const { afterCustomerTag } = res.data
        res.data.afterCustomerTag = afterCustomerTag === null ? '' : afterCustomerTag
        this.eventInfoObj = res.data
        this.$set(this.eventInfoObj, 'afterCustomerTag', res.data.afterCustomerTag)
        this.handleSchedule(res.data.scheduleList)
        if (this.eventActive === 0) {
          this.$nextTick(() => {
            this.$refs.feedbackRef.getFeedbackInfo()
            this.$refs.feedbackRef.getSummaryInfo()
          })
        }
      })
    },
    changeTab (val) {
      this.handleBeforeTabChange(val)
    },
    handleSchedule (data = []) {
      if (data.length > 0) {
        if (this.eventInfoObj.days > 1) {
          let isFlag = false
          let summaryObj = {}
          data.forEach((subItem, subIndex) => {
            if (subItem.isLock) {
              isFlag = true
            }
            subItem.reportDate = `${subItem.reportDate} · ${this.$t('shared.day')} ${subIndex + 1}`
            subItem.newReportData = `${this.$t('shared.daily')} · ${this.$t('shared.day')} ${subIndex + 1}`
            // if (subItem.isChoose && this.eventInfo.schedule !== '-1') {
            //   if (this.eventInfoObj.status === 0) {
            //     this.currentSchedule = subItem
            //   }
            // }
          })
          summaryObj = { reportDate: 'Summary', newReportData: this.$t('shared.summary'), isChoose: false, isLock: isFlag, schedule: '-1' }
          if (this.eventInfoObj.status === 0) {
            this.currentSchedule = data[0]
          } else if (this.eventInfoObj.status === 2) {
            this.currentSchedule = { reportDate: 'Summary', newReportData: this.$t('shared.summary'), isChoose: false, isLock: isFlag, schedule: '-1' }
          } else if (this.eventInfoObj.status === 1) {
            for (let i = data.length - 1; i >= 0; i--) {
              if (data[i].isLock === false) {
                this.currentSchedule = data[i]
                break
              }
            }
          } else {
            if (!this.currentSchedule.schedule) this.currentSchedule = { reportDate: 'Summary', newReportData: this.$t('shared.summary'), isChoose: false, isLock: isFlag, schedule: '-1' }
          }
          data.push(summaryObj)
        }
      }
      this.scheduleList = data
      this.SET_EVENTINFO({ eventId: this.eventId, schedule: this.currentSchedule.schedule || '' })
    },
    backReturn () {
      this.SET_EVENTINFO({ eventId: '', schedule: '' })
      this.$destroy()
    },
    getCurrentLoc () {
      Toast.loading({
        message: this.$t('shared.loading'),
        forbidClick: true,
        duration: 0
      })
      const currentTimeLoc =
        JSON.parse(window.localStorage.getItem('currentTimeLoc')) || {}
      this.getlocation(currentTimeLoc.lat, currentTimeLoc.lng, this.eventInfoObj.address)
    },
    getlocation (lat, lng, toAddress) {
      // 根据经纬度获取位置
      new google.maps.Geocoder().geocode(
        {
          location: new google.maps.LatLng(lat, lng)
        },
        function geoResults (results, status) {
          Toast.clear()
          // 这里处理结果和上面一模一样
          if (status === google.maps.GeocoderStatus.OK) {
            window.location.href = `https://www.google.com/maps/dir/?api=1&dir_action=navigate&origin=${results[0].formatted_address}&destination=${toAddress}&waypoints=`
          } else {
            console.log('：error ' + status)
          }
        }
      )
    },
    toPage (url, type) {
      if (type === 'detail') {
        this.$router.replace(url)
      } else {
        this.$router.push(url)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.event-detail {
  display: flex;
  flex-direction: column;
  height: 100%;
  .top-content {
    padding: 10px;
  }
  .header-info {
    width: 100%;
    padding: 10px;
    box-shadow: 0 2px 8px rgba(0,0,0,0.15);
    border-radius: 8px;
    .card-header {
      margin-bottom: 8px;

      .title-row {
        display: flex;
        align-items: center;

        .event-title {
          max-width: 280px;
          font-size: 14px;
          font-weight: bold;
          color: #333;
          margin-right: 8px;
        }

        .status-tag {
          max-width: 66px;
          font-size: 10px;
          padding: 2px 6px;
          border-radius: 2px;
          color: #fff;
          background-color: #f59a23;
        }
      }
    }
    .info-row {
      display: flex;
      align-items: center;
      margin-bottom: 6px;
      color: #666;
      line-height: 1.4;

      .row-icon {
        width: 13px;
        height: 13px;
        margin-right: 6px;
        object-fit: contain;
      }

      .info-text {
        flex: 1;
      }

      .time-content {
        display: flex;
        align-items: center;
        flex-wrap: wrap;

        .time-status-badge {
          max-width: 100px;
          font-size: 10px;
          padding: 1px 4px;
          border-radius: 2px;
          margin-right: 6px;
          border: 1px solid currentColor;
          &.status-not-started {
            color: #d45648;
            background: #f7c9ce;
            border-color: #d45648;
          }
          &.status-starting {
            color: #1f9d16;
            background: #d2f6d1;
            border-color: #1f9d16;
          }
          &.status-end {
            color: #898989;
            background: #e6e6e6;
            border-color: #898989;
          }
          &.status-archive {
            color: #307bff;
            border-color: #307bff;
            background: #e9effc;
          }
        }

        .time-range {
          color: #666;
        }
      }
      .navigate-info {
        display: flex;
        align-items: center;
        padding: 4px 4px;
        font-size: 10px;
        border-radius: 3px;
        color: #fff;
        background-color: #307bff;
      }
    }
    .tags-row {
      align-items: flex-start;
      .tags-list {
        display: flex;
        flex-wrap: wrap;
        gap: 6px;

        .product-tag {
          font-size: 10px;
          padding: 1px 6px;
          border-radius: 2px;
          border: 1px solid;
        }
      }
    }
    .store-row {
      margin-bottom: 0;
      align-items: center;

      .store-name {
        flex: 1;
        color: #666;
      }
    }
  }
  .product-name-header {
    padding: 0 10px;
    color: #307bff;
    font-weight: bold;
    font-size: 16px;
    margin-bottom: 10px;
    .title-wrapper {
      display: inline-block;
      cursor: pointer;
      .title-name {
        max-width: 336px;
        display: flex;
        align-items: center;
        .arrow-icon {
          font-size: 12px;
          margin-left: 4px;
          transform: rotate(90deg);
          transition: transform 0.2s;
          &.expanded {
            transform: rotate(-90deg);
          }
        }
      }
    }
    .bot-line {
      height: 4px;
      background: linear-gradient(to right, #b6ccdf 0%, #307bff 100%);
      border-radius: 2px;
      margin-top: 4px;
    }
  }
  .event-tabs {
    margin-top: 10px;
  }
  /deep/.van-tabs {
    .van-tab__text {
      font-weight: bold;
    }
    .van-hairline--bottom::after {
      border-bottom: none;
    }
    .van-tabs--card {
      padding: 0 10px;
      padding-top: 5px;
      background-color: #fff;
      z-index: 99;
    }
    .van-tabs__nav--card {
      margin: 0;
    }
    .van-tabs__wrap {
      height: 30px;
    }
  }
  .main-content {
    flex: 1;
    overflow-y: auto;
  }
  .footer-btn {
    display: flex;
    // box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.15);
    box-shadow: 0 0px 8px rgba(0,0,0,0.3);
    z-index: 9;
    .previous-btn,
    .next-btn {
      border: none;
      font-weight: bold;
    }
    .previous-btn {
      color: #307bff;
    }
    .next-btn {
      background-color: #307bff;
    }
    .save-btn {
      background-color: #307bff;
      color: #fff;
    }
  }
}
.popover-content {
  padding: 8px 0;
  min-width: 160px;
  .popover-item {
    display: flex;
    align-items: center;
    padding: 10px;
    font-size: 12px;
    color: #333;
    cursor: pointer;
    &.active {
      color: #307bff;
      background-color: #f5faff;
    }
    &.disabled {
      color: #ccc;
      cursor: not-allowed;
    }
    &:active:not(.disabled) {
      background-color: #f2f3f5;
    }
    .icon-wrapper {
      width: 20px;
      margin-right: 8px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .text {
      flex: 1;
    }
  }
}
</style>
